import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { usePermissionRules } from 'hooks/permissionRules';
import { useGuide } from '../../hooks/useGuide';

type GuideMenuProps = {
  anchorEl: HTMLButtonElement | null;
};

const GuideMenu: React.FC<GuideMenuProps> = ({ anchorEl }) => {
  const { selectedGuide, setAnchorEl, setSelectedGuide, setViewGuide, setCancelGuide, setFinishGuide, setNoShowGuide } =
    useGuide();
  const { checkPermission } = usePermissionRules();
  const canCancel = selectedGuide?.status !== 'deleted';
  const canNoShow = selectedGuide?.status === 'scheduled';
  const canFinish = selectedGuide?.status !== 'completed' && selectedGuide?.status !== 'deleted';

  function handleClose() {
    setAnchorEl(null);
  }

  function handleCloseAndClear() {
    handleClose();
    setSelectedGuide(null);
  }

  function handlePrint() {
    window.open(`/guides/${selectedGuide?.id}/print`, '_blank');
    handleCloseAndClear();
  }

  function handleView() {
    handleClose();
    setViewGuide(true);
  }

  function handleNoShow() {
    if (!canNoShow) return;
    handleClose();
    setNoShowGuide(true);
  }

  function handleCancel() {
    if (!canCancel) return;
    handleClose();
    setCancelGuide(true);
  }

  function handleFinish() {
    if (!canFinish) return;
    handleClose();
    setFinishGuide(true);
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseAndClear}>
      <MenuItem onClick={handlePrint}>Imprimir guia</MenuItem>
      <MenuItem onClick={handleView}>Visualizar</MenuItem>
      {checkPermission('ambulatory.guide.finish-guide') && (
        <MenuItem disabled={!canNoShow} onClick={handleNoShow}>
          Marcar como faltou
        </MenuItem>
      )}
      {checkPermission('ambulatory.guide.cancel-guide') && (
        <MenuItem disabled={!canCancel} onClick={handleCancel}>
          Cancelar guia
        </MenuItem>
      )}
      {checkPermission('ambulatory.guide.finish-guide') && (
        <MenuItem disabled={!canFinish} onClick={handleFinish}>
          Concluir guia
        </MenuItem>
      )}
    </Menu>
  );
};

export default GuideMenu;
